import { z } from 'zod';

export const TIME_ZONE_OPTIONS = [
  'America/Vancouver',
  'America/Edmonton',
  'America/Regina',
  'America/Winnipeg',
  'America/Toronto',
  'America/Halifax',
  'America/St_Johns',
] as const;

export type CanadianTimeZone = (typeof TIME_ZONE_OPTIONS)[number];

export const CANADIAN_TIME_ZONES: Record<CanadianTimeZone, string> = {
  'America/Vancouver': 'Vancouver',
  'America/Edmonton': 'Edmonton',
  'America/Regina': 'Regina',
  'America/Winnipeg': 'Winnipeg',
  'America/Toronto': 'Toronto',
  'America/Halifax': 'Halifax',
  'America/St_Johns': "St. John's",
};

export const DEFAULT_SITE_TIME_ZONE: CanadianTimeZone = 'America/Winnipeg';

export const canadianTimeZoneSchema = z.enum(TIME_ZONE_OPTIONS);
